// extracted by mini-css-extract-plugin
export var infoRow = "_uv-2";
export var labelContainer = "_uv-0";
export var rightInfo = "_uv-1";